'use client'

import clsx from 'clsx';
import Cta from '@/components/cta/cta';
import ArrowLeft from '@/components/icon/arrow-left';
import ArrowRight from '@/components/icon/arrow-right';

export default function OverlayArrowControls({
  previousRoute,
  nextRoute,
  onClick,
  isVisible = true,
  className,
  prevRef,
  nextRef,
  isLight = false,
}) {
  return (
    <div
      className={clsx(
        'absolute top-[calc(2rem)] left-6 pointer-events-none lg:justify-between lg:fixed lg:top-1/2 lg:left-0 lg:-translate-y-1/2 lg:w-full lg:px-(--space-8) lg:py-0',
        className
      )}
      aria-label="Story navigation"
    >
      <div
        className={clsx(
          'relative px-2 py-(--space-3) rounded-[100px] before:rounded-[100px] before:absolute before:pointer-events-none before:inset-0 before:mix-blend-overlay before:[transform:translateZ(0)] before:transition-[background-color] before:duration-300 lg:rounded-none lg:px-0 lg:py-0 lg:before:hidden',
          isVisible
            ? (isLight ? 'before:bg-white/35' : 'before:bg-black/35')
            : (isLight ? 'before:bg-white/0' : 'before:bg-black/0'),
        )}
      >
        <div className={clsx(
          'relative flex gap-x-(--space-4) transition-opacity motion-safe:duration-300 lg:justify-between lg:w-full',
          isVisible ? 'opacity-100' : 'opacity-0'
        )}>
          <Cta
            ref={prevRef}
            className="cta-light cta-icon-stroke-theme cta-circle-small pointer-events-auto xl:cta-circle"
            aria-label="Previous story"
            href={previousRoute}
            transitionName="slide-right"
            onClick={onClick}
          >
            <ArrowLeft className="!w-4 xl:!w-4.5" aria-hidden="true" />
          </Cta>

          <Cta
            ref={nextRef}
            className="cta-light cta-icon-stroke-theme cta-circle-small pointer-events-auto xl:cta-circle"
            aria-label="Next story"
            href={nextRoute}
            transitionName="slide-left"
            onClick={onClick}
          >
            <ArrowRight className="!w-4 xl:!w-4.5" aria-hidden="true" />
          </Cta>
        </div>
      </div>
    </div>
  );
}
